import React from "react";
import "./i18n";
import ParticlesBackground from "./components/Background/ParticlesBackground.js";
import Navbar from "./components/NavBar/Navbar";
import Hero from "./components/Hero/Hero";
import About from "./components/About/About";
import Portfolio from "./components/Portfolio/Portfolio";
// import PortfolioCards from "./components/PortfolioCards/PortfolioCards";
import Contact from "./components/Contact/Contact";

function App() {
  return (
    <div className="App">
      <ParticlesBackground />
      <Navbar />
      <div className="page-container">
        <section id="home" className="section"></section>
        <Hero />
        <section id="about" className="section"></section>
        <About />
        <section id="portfolio" className="section"></section>
        <Portfolio />
        {/* <PortfolioCards /> */}
        <section id="contact" className="section"></section>
        <Contact />
      </div>
    </div>
  );
}

export default App;
